// extracted by mini-css-extract-plugin
export default {"purpose":"purpose_purpose__jpAob","title":"purpose_title__7WDuO"};